// extracted by mini-css-extract-plugin
export default {"container":"PageContent__container-QOw8y","containerWithBanner":"PageContent__containerWithBanner-pDb3w"};